module.exports = __webpack_public_path__ + "images/store_noimage_5aa77d2cd168ffc7bfa2be3fa43eb736.gif";